import AttachmentPermissionLevel from 'owa-service/lib/contract/AttachmentPermissionLevel';
import SetAttachmentPermissionsResponse from 'owa-service/lib/contract/SetAttachmentPermissionsResponse';
import setAttachmentPermissionsRequest from 'owa-service/lib/factory/setAttachmentPermissionsRequest';
import setAttachmentPermissionsV2Operation from 'owa-service/lib/operation/setAttachmentPermissionsV2Operation';

function createRequestBody(
    attachmentIds: string[],
    permissionLevel: AttachmentPermissionLevel,
    newAttachLongPathNames: string[] = null,
    setToOriginalPermissionLevel: boolean = false
) {
    return setAttachmentPermissionsRequest({
        AttachmentIds: attachmentIds,
        PermissionLevel: permissionLevel,
        NewAttachLongPathNames: newAttachLongPathNames,
        SetToOriginalPermissionLevel: setToOriginalPermissionLevel,
    });
}

export default function setAttachmentPermissionsService(
    attachmentIds: string[],
    permissionLevel: AttachmentPermissionLevel,
    newAttachLongPathNames: string[] = null,
    setToOriginalPermissionLevel: boolean = false
): Promise<SetAttachmentPermissionsResponse> {
    const requestBody = createRequestBody(
        attachmentIds,
        permissionLevel,
        newAttachLongPathNames,
        setToOriginalPermissionLevel
    );
    return setAttachmentPermissionsV2Operation({
        request: requestBody,
    });
}
